import { createGogoRouteMatcher } from '@tencent/wuji-gogo-runtime/core';
export const GOGO_RUNTIME_WILDCARD_NAME = 'gogoRuntimeWildcard';
export const GOGO_RUNTIME_NOT_FOUND_PATH = '/404';
export function isGogoWildcardRoute(route) {
    if (route.path === GOGO_RUNTIME_NOT_FOUND_PATH)
        return false;
    if (route.name === GOGO_RUNTIME_WILDCARD_NAME)
        return true;
    return !!route.matched?.some(record => record.meta?.gogoWildcard);
}
export function matchGogoPagePath(path, pages) {
    const matcher = createGogoRouteMatcher(pages.map(page => ({
        path: page.routePath,
    })));
    return matcher.resolve({ path }).matched.length > 0;
}
export function shouldRedirectGogoWildcardTo404(opts) {
    if (!opts.routeTableReady)
        return false;
    if (!opts.isWildcardRoute)
        return false;
    if (opts.path === GOGO_RUNTIME_NOT_FOUND_PATH)
        return false;
    return !matchGogoPagePath(opts.path, opts.pages);
}
let routeTablePages = [];
let routeTableReady = false;
let guardInstalled = false;
export function setGogoRouteTable(pages, ready = true) {
    routeTablePages = pages;
    routeTableReady = ready;
}
function shouldRedirectCurrentRoute(route) {
    return shouldRedirectGogoWildcardTo404({
        routeTableReady,
        isWildcardRoute: isGogoWildcardRoute(route),
        path: route.path,
        pages: routeTablePages,
    });
}
export function flushGogoWildcardNotFoundCheck(router) {
    if (!shouldRedirectCurrentRoute(router.currentRoute))
        return;
    router.replace(GOGO_RUNTIME_NOT_FOUND_PATH).catch(() => undefined);
}
export function ensureGogoWildcardNotFoundGuard(router) {
    if (guardInstalled)
        return;
    guardInstalled = true;
    router.afterEach((to) => {
        if (!shouldRedirectCurrentRoute(to))
            return;
        router.replace(GOGO_RUNTIME_NOT_FOUND_PATH).catch(() => undefined);
    });
}
export function applyGogoWildcardNotFound(router, pages, ready = true) {
    setGogoRouteTable(pages, ready);
    ensureGogoWildcardNotFoundGuard(router);
    flushGogoWildcardNotFoundCheck(router);
}
/** 仅单测重置模块状态 */
export function resetGogoWildcardNotFoundForTest() {
    routeTablePages = [];
    routeTableReady = false;
    guardInstalled = false;
}
